const Form041EN = {
    stepName: {
        ImportantNotes: "Important Notes",
        RegistrationAs: "Application for registration as",
        PersonalParticulars: "Personal Particulars",
        ChildCareTraining: "Child Care Training",
        ChildCareExperience: "Child Care Experience",
        Annex: "Annex",
        Confirmation: "Confirmation",
    },
    ChildrenAgeOption: {},
    FirstAidTrainingOption: {},
    dateOfResignationOptions: {
        yes: "Yes",
        no: "No",
    },
    toolTip: {
        course: "#Only English course name will be provided.",
    },
    importantNotes: {
        p_title: "Personal Information Collection Statement",

        p_title_one: "<u>Purpose of Collection</u>",
        p1_1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        p1_a: "Activities relating to the processing, authentication and counter-checking of the application for registration of child care supervisor and / or child care worker; ",
        p1_b: "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
        p1_c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
        p1_d: "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
        p1_e: "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
        p1_f: "Activities relating to compilation of statistics, research and Government publications; and",
        p1_g: "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules), the Codes of Aid; and the Child Care Services Ordinance (Cap.243) and  its subsidiary legislation ( i.e., the Child Care Services Regulations (Cap 243 A) ) ",
        p2: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",

        p_title_two: "<u>Classes of Transferees</u>",
        p3: "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:- ",
        p3_a: "other Government bureau and departments, including Social Welfare Department, for the purposes mentioned in paragraph 1 above;",
        p3_b: "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
        p3_c: "where you have given your prescribed consent to such disclosure; and",
        p3_d: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",

        p_title_three: "<u>Access to Personal Data</u>",
        p4: "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to intake officer at Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong or email to ",
    },
    notes: {
        title: "<u>Important Notes<u>",
        bracket: ")",
        url: "https://www.edb.gov.hk/en/edu-system/preprimary-kindergarten/application-for-registration-as-child-care-worker-supervisor/index.html",
        pographyOne:
            "According to Regulation 3(1)(a) or/and 3(1)(b), applicant has to successfully complete a training course approved by the Director of Social Welfare before he / she is eligible for registration. For the list of approved courses qualifying for registration of Child Care Worker and Child Care Supervisor, please refer to the Education Bureau website(",
        pographyTwo:
            "Applicant without an “iAM Smart+” account is required to print out and submit by post or in person the completed application form to the Joint Office for Kindergartens and Child Care Centres, Education Bureau at Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong, together with the following documents:",
        pographyTwo_a: "a) Photocopy of identity card or passport;",
        pographyTwo_b:
            "b) Three identical formal photographs with name written at the back; and",
        pographyTwo_c:
            "c) Photocopy of certificates of relevant child care training.",
        pographyThree:
            "Please ensure that sufficient postage is paid to avoid unsuccessful delivery. Any underpaid mail items will be disposed of by the Hongkong Post.",
        pographyFour: "Do NOT staple together the documents submitted.",
        pographyFive:
            "<u>Applicant is normally required to attend an interview with the processing officer of this Office and provide original copies of the documents stated in (1) above for verification and applicants who submitted application by electronic have to produce three identical formal photographs at the interview.</u>",
        pographySix:
            "Applicant’s name, registration number and the date of registration will be subject to inspection by the public in accordance with the provision stipulated in Regulation 3 of the Child Care Services Regulations.",
        pographySeven:
            "For enquiries of the procedures, please contact this Office at 3107 2197 or via ",
        pographySeven_url: "jokc@edb.gov.hk",
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        statement: "Statement",
        typeHeader: "Application for registration as",
        personalData: "<u>Provision / Handling of Personal Data</u>",
        personalParticulars: "Personal Particulars",
        childCareTraining: "Child Care Training",
        childCareExperience:
            "Child Care Experience (Excluding fieldwork experience)",
        idAnnex: "Attachment (Photocopy of identity card or passport)",
        photograph: "Attachment (Applicant’s Formal Photograph)",
        training:
            "Attachment (Photocopy of certificates of relevant child care training)",
        dot: ".",
        registeringCCSCCWSameTime:
            "If you have completed this course, you can consider applying for registering as a Child Care Worker and a Child Care Supervisor at the same time.",
    },
    otherNotes: {
        pographyOne:
            "The personal data supplied by the applicant will be used by this Office for registration purpose, <u>including but not limited to monitoring and review of registration procedures and conducting of research and surveys, and for discharging statutory duties.</u> The provision of personal data to this Office is voluntary. If the applicant does not provide sufficient personal data, we may not be able to process his / her application.",
        pographyTwo:
            "The personal data may be disclosed to other Government bureaux / departments for the purposes stated in (1) above; or where the applicant has given consent to such disclosure; or where such disclosure is authorized or required by law.",
        pographyThree:
            "Please ensure that the data provided to this Office are accurate. Except where there is an exemption provided under the Personal Data (Privacy) Ordinance, the applicant has a right of access to and correction of personal data held on him / her. The applicant can also obtain copies of his / her personal data subject to the payment of necessary administrative charges. If the applicant has enquiries concerning access to or changes in the data he / she has provided, please contact this Office at 3107 2197 or via ",
        pographyThree_url: "jokc@edb.gov.hk",
    },
    label: {
        registrationType: "Application for registration as:",
        supervisor: "Child Care Supervisor",
        childCareWorker: "Child Care Worker",
        title: "Title",
        // titleOption: {
        //     mr: "Mr.",
        //     mrs: "Mrs.",
        //     miss: "Miss.",
        //     ms: "Ms.",
        // },
        ccwSchoolOption: {
            1: "SWD, Training Section 社會福利署訓練組",
            2: "Hong Kong Polytechnic University 香港理工大學",
            3: "The Hong Kong Institute of Vocational Education (Lee Wai Lee) 香港專業教育學院李惠利分校",
            4: "The Hong Kong Institute of Vocational Education (Sha Tin) 香港專業教育學院沙田分校",
            5: "Hong Kong Baptist University, School of Continuing Education 香港浸會大學持續教育學院",
            6: "Hong Kong Institute of Education 香港教育學院 ／ The Education University of Hong Kong 香港教育大學",
            7: "The University of Hong Kong 香港大學",
            8: "The Open University of Hong Kong 香港公開大學",
            9: "Li Ka Shing Institute of Professional and Continuing Education / Li Ka Shing School of Professional and Continuing Education 香港公開大學李嘉誠專業進修學院",
            10: "Yew Chung Community College 耀中社區書院",
            11: "Yew Chung College of Early Childhood Education 耀中幼教學院",
            12: "Caritas Institute of Community Education 明愛社區書院",
            13: "Caritas Institute of Higher Education 明愛專上學院",
            14: "The Chinese University of Hong Kong 香港中文大學",
            15: "The School of Continuing and Professional Studies of the Chinese University of Hong Kong 香港中文大學專業進修學院",
            16: "Tung Wah College 東華學院",
            17: "Lingnan Institute of Further Education 嶺南大學持續進修學院",
            18: "Gratia Christian College 宏恩基督教學院",
            19: "Hong Kong College of Technology (HKCT) Institute of Higher Education 港專學院",
        },
        ccsSchoolOption: {
            5: "Hong Kong Baptist University, School of Continuing Education 香港浸會大學持續教育學院",
            6: "Hong Kong Institute of Education 香港教育學院 / The Education University of Hong Kong 香港教育大學",
            2: "Hong Kong Polytechnic University 香港理工大學",
            3: "The Hong Kong Institute of Vocational Education (Lee Wai Lee) 香港專業教育學院李惠利分校",
            4: "The Hong Kong Institute of Vocational Education (Sha Tin) 香港專業教育學院沙田分校",
            7: "The University of Hong Kong 香港大學",
            8: "The Open University of Hong Kong 香港公開大學",
            9: "Li Ka Shing Institute of Professional and Continuing Education /Li Ka Shing School of Professional and Continuing Education The Open University of Hong Kong 香港公開大學李嘉誠專業進修學院",
            14: "The Chinese University of Hong Kong 香港中文大學",
            15: "The School of Continuing and Professional Studies of the Chinese University of Hong Kong 香港中文大學專業進修學院",
            10: "Yew Chung Community College 耀中社區書院",
            11: "Yew Chung College of Early Childhood Education 耀中幼教學院",
            12: "Caritas Institute of Community Education 明愛社區書院",
            13: "Caritas Institute of Higher Education 明愛專上學院",
            16: "Tung Wah College 東華學院",
            17: "Lingnan Institute of Further Education 嶺南大學持續進修學院",
            18: "Gratia Christian College 宏恩基督教學院",
            19: "Hong Kong College of Technology (HKCT) Institute of Higher Education 港專學院",
        },
        ccwCourseOption: {
            1: {
                1: "In-service Training Course for Nursery Workers#[Since13.8.1979]",
                2: "In-service Training Course for Crèche Workers#[Since13.8.1979]",
                3: "In-service Training Course for Playgroup Leaders#[Since13.8.1979]",
                4: "Pre-school Education Course Service Children Education Authority,Teachers’Centre, British Forces, HK#[Since13.8.1979]",
                5: "Hong Kong Nursery Workers’ Training Course, joint project of SWD &YWCA#[Since13.8.1979]",
                6: "Elementary Child Care Course#Since6.11.1979]",
            },
            2: {
                1: "Certificate in Child Care (1 year full time)#[Since13.8.1979]",
                2: "Part-time Day Release Certificate Course in Child Care (2 year part-time)#[Since13.8.1979]",
                3: "In-service Training Course for Nursery Workers#[Since5.5.1988]",
                4: "Basic Course for Child Care Workers#[Since5.5.1988]",
                5: "Basic Course for English-speaking Child Care Workers#[Since5.5.1988]",
                6: [
                    "The Certificate Course in Pre-primary Education (Distance Learning Mode)[Since 10.7.1989]",
                    "學前教育證書課程(遙距課程)[自10.7.1989開始]",
                ],
                7: [
                    "Certificate Course in Pre-primary Education for 2000/2001 (1 year pre-service full-time)[Since operation]",
                    "2000/2001學前教育證書課程(一年全日制職前課程)[自開辦始]",
                ],
                8: [
                    "Bachelor of Arts (Honours) in Pre-primary Education [Students who have successfully completed Stage 1 and 2 of the Bachelor of Arts (Honours) in Pre-primary Education may apply for individual recognition of Child Care worker equivalent qualification.][Since 18.2.2002]",
                    "學前教育(榮 譽)文學士學位課程[已成功完成學前教育(榮譽)文學士學位課程第一及第二階段課程之學員，可申請獨立認可其幼兒工作員等同資歷][自18.2.2002開始]",
                ],
            },
            3: {
                1: "Certificate Course in Child Care#[Since6.2.1981]",
                2: "Certificate in Care of Pre-school Children (2 year full-time)#[Since5.5.1988]",
                3: [
                    "Certificate in Child Care (1 year full time pre-service mode)[Since 5.5.1988]",
                    "幼兒工作證書(一年全日職前訓練制)[自5.5.1988開始]",
                ],
                4: [
                    "Certificate in Child Care (2 year part-time day release in-service mode)[Since 5.5.1988]",
                    "幼兒工作證書(兩年日間部份時間給假調訓在職訓練制)[自5.5.1988開始]",
                ],
                5: [
                    "Vocational Certificate in Basic Child Care Work (1 year part-time day release in-service mode)The course was named as Certificate in Basic Child Care Work (1 year part-time day release in-service mode) prior to 1999-2000.[Since 3.3.1995]",
                    "基本幼兒工作職業技術證書(一年日間部份時間給假調訓在職訓練制)此課程於1999/2000前稱為基本幼兒工作證書[自3.3.1995 開始]",
                ],
                6: "Basic Course for English-speaking Child Care Workers#[Since3.3.1995]",
                7: [
                    "Diploma in Child Care and Education (pre-service 2 year full time)[Since 27.11.2001]",
                    "幼兒教育文憑(兩年全日職前訓練制)[自27.11.2001開始]",
                ],
                8: [
                    "Higher Diploma in Child Care and Education (pre-service 3 year full time)[Students who have successfully completed Year One of Higher Diploma in Child Care & Education may apply for individual assessment of Child Care Worker equivalent qualification.][Since 27.11.2001]",
                    "幼兒教育高級文憑(三年全日職前訓練 制)[已成功完成幼兒教育高級文憑(三年全日職前訓練制)第一年課程之學員，可申請獨立評估其幼兒工作員等同資歷。][自27.11.2001 開始]",
                ],
                9: [
                    "Higher Diploma in Child Care and Education (pre-service 2 year full time)[Graduatesfrom July 2009 onwards]",
                    "幼兒教育高級文憑(兩年全日職前訓練制)[自2009年7月或以後畢業生開始]",
                ],
            },
            4: {
                1: [
                    "Higher Diploma in Child Care and Education (pre-service 3 year full time)[Since operation]",
                    "幼兒教育高級文憑(三年全日職前訓練制)[自開辦始]",
                ],
                2: [
                    "Higher Diploma in Child Care and Education (pre-service 2 year full time)[Since operation]",
                    "幼兒教育高級文憑(兩年全日職前訓練制)[自開辦始]",
                ],
                3: [
                    "Higher Diploma in Child Care and Education (3-year part time evening) [Graduates from 2008 to 2012 could be registered with satisfactory completion of the Certificate in Basic Child Care Work (Bridging Course) organised by The Hong Kong Institute of Vocational Education (Sha Tin).]",
                    "幼兒教育高級文憑 (三年晚間兼讀制)[2008至2012年期間的畢業生，可透過成功完成香港專業教育學院沙田分校舉辦的「基本幼兒工作証書(銜接課程)」，以達到註冊要求][2013年或以後畢業]",
                ],
                4: [
                    "Higher Diploma in Special Child Care and Inclusive Education[Graduate from 2019 to 2022]",
                    "特殊幼兒照顧及融合教育高級文憑[2019至2022年畢業]",
                ],
            },
            5: {
                1: [
                    "Certificate Course in Early Childhood Education [Graduates before 4.6.1997 could be registered with completion of the Conversion Programme in Early Childhood Education organized by HKBU.][Since 4.6.1997]",
                    "幼兒教育證書課程[4.6.1997前的畢業生可透過完成香港浸會大學舉辦的幼兒教育銜接課程以達到註冊要求][自4.6.1997 開始]",
                ],
                2: [
                    "One-year Pre-service Basic Early childhood Education Course for 2001-02[Since operation]",
                    "2001/2002一年全日制職前幼兒教師培訓課程[自開辦始]",
                ],
                3: [
                    "Higher Diploma in Early Childhood Education[Since September 2007]",
                    "幼兒教育高級文憑課程[自2007年9月開始]",
                ],
                4: [
                    "Postgraduate Diploma in Early Childhood Education[Since June 2009]",
                    "幼兒教育深造文憑課程[自2009年6月開始]",
                ],
                5: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Since 2012/13 School Year]",
                    "幼兒教育學教育學士(榮譽)學位[自2012/13學年開始]",
                ],
            },
            6: {
                1: [
                    "Qualified Kindergarten Teacher Education Course (Chinese) (1 year day release or evening mixed mode)[Since 9.12.1997]",
                    "合格幼稚園教師在職訓練課程(中文)(一年日間/夜間混合制)[自9.12.1997開始]",
                ],
                2: [
                    "Qualified Kindergarten Teacher Education (Conversion) Course (Chinese) (1 year day release or evening mixed mode)[Since 9.12.1997]",
                    "合格幼稚園教師轉讀課程(中文)(一年日間/夜間混合制)[自9.12.1997開始]",
                ],
                3: [
                    "Qualified Kindergarten Teacher Education Course (English) (1 year day release mode)[Since 3.3.2001]",
                    "合格幼稚園教師在職訓練課程(英文)(一年日間部份時間給假制)[自3.3.2001開始]",
                ],
                4: [
                    "Qualified Kindergarten Teacher Education Course (Chinese) (2 year part-time evening)[Since 5.6.2001]",
                    "合格幼稚園教師在職訓練課程(中文)(二年夜間部份時間制)[自5.6.2001開始]",
                ],
                5: [
                    "Qualified Kindergarten Teacher Education Course (Conversion) (Chinese) (2 year part-time evening)[Since 5.6.2001]",
                    "合格幼稚園教師轉讀課程(中文)(二年夜間部份時間制)[自5.6.2001開始]",
                ],
                6: [
                    "Qualified Kindergarten Teacher Education Course (Chinese) (1 year full time)[Since 5.6.2001]",
                    "合格幼稚園教師訓練課程(中文)(一年全日制)[自5.6.2001開始]",
                ],
                7: [
                    "Certificate in Early Childhood Education (Chinese) Programme (3 year full time)[Renamed as Higher Diploma in Early Childhood Education Programme (2-year full-time) and (3-year full-time) from 2009/10 school year. First cohort of graduates is expected in 2011 & 2012.][Since 30.8.1999]",
                    "幼兒教育證書(中文)課程(三年全日制)[由2009/10學年開始，課程名稱改為幼兒教育高級文憑課程(二年全日制)及(三年全日制)。第一批學生預計於2011年及2012年畢業][自30.8.1999 開 始]",
                ],
                8: [
                    "Bachelor of Education (Honours) (Early Childhood Education)[Bed(ECE)](4 year full time)[Since 13.7.2005]",
                    "幼兒教育榮譽學士[Bed(ECE)](四年全日制)[自13.7.2005開始]",
                ],
                9: [
                    "Bachelor of Education (Honours) (Early Childhood Education)[Bed(ECE)](5 year full time)[Graduate from 2016/17 School Year onwards]",
                    "幼兒教育榮譽學士[Bed(ECE)](五年全日制)[2016/17學年或以後畢業]",
                ],
                10: [
                    "Postgraduate Diploma in Education (Early Childhood Education)[PGDE(ECE)](2 year part-time in-service)[Since 13.7.2005] ",
                    "學位教師教育文憑課程(幼兒教育)[PGDE(ECE)](二年部份時間制)[自13.7.2005開始]",
                ],
                11: [
                    "Postgraduate Diploma in Education (Early Childhood Education)[PGDE(ECE)] (2 year part-time)[Since 2015/16 School Year]",
                    "學位教師教育深造文憑(幼兒教育)(二年兼讀制)[自2015/16學年開始]",
                ],
                12: [
                    "Postgraduate Diploma in Education (Early Childhood Education)[PGDE(ECE)] (1 Year Full-time)[Graduate from 2017/18 School Year onwards]",
                    "學位教師教育深造文憑(幼兒教育)(一年全日制)[自2017/18學年或以後畢業]",
                ],
            },
            7: {
                1: "PGDE (Major in Early Childhood Education)#[Since9.2.2007]",
                2: [
                    "Bachelor of Science in Applied Child Development[Since operation]",
                    "理學士(應用兒童發展)[自開辦始]",
                ],
                3: [
                    "Bachelor of Education in Early Childhood Education and Special Education (5-year Full-time)[Graduate from 2024 onwards]",
                    "教育學士(幼兒教育及特殊教育)(五年全日制)[2024年或以後畢業]",
                ],
            },
            8: {
                1: "Diploma in Early Childhood Education#[Since 28.2.2007]",
                2: [
                    "Bachelor of Education with Honours in Early Childhood Education (Leadership and Special Educational Needs)[Graduate from 2022 onwards]",
                    "教育榮譽學士(幼兒教育：領導及特殊教育需要)[2022年或以後畢業]",
                ],
            },
            9: {
                1: "Diploma in Enlightened Early Childhood Education#[Since31.3.2008]",
                2: [
                    "Higher Diploma in Early Childhood Education[Since 2012/13 School Year]",
                    "幼兒教育高級文憑[自2012/13學年開始]",
                ],
            },
            10: {
                1: [
                    "Higher Diploma in Early Childhood Education [Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.][Graduate from 2016 to 2024]",
                    "幼兒教育高級文憑[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。][2016至2024年畢業]",
                ],
            },
            11: {
                1: [
                    "Higher Diploma in Early Childhood Education [Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.][Graduate from 2019 to 2024]",
                    "幼兒教育高級文憑[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。][2019至2024年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education [BEd(ECE)][Graduate from 2022 to 2026]",
                    "幼兒教育(榮譽)學士[2022至2026年畢業]",
                ],
            },
            12: {
                1: [
                    "Higher Diploma in Early Childhood Education[Full-time students will graduate from 2017 to 2022 , Part-time students will graduate in 2019 and 2020]",
                    "幼兒教育高級文憑[全日制學生於2017至2022年畢業,兼讀制學生於2019及2020年畢業]",
                ],
            },
            13: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2019 to 2023]",
                    "幼兒教育高級文憑[2019至2023年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Graduate from 2024 to 2027]",
                    "幼兒教育榮譽學士[2024至2027年畢業]",
                ],
            },
            14: {
                1: "Postgraduate Diploma in Education (Early Childhood Education)[Graduate from 2016/17 School Year onwards][2016/17學年或以後畢業]",
                2: [
                    "Bachelor of Education Programme in Early Childhood Education [Graduate from 2024 onwards]",
                    "幼兒教育教育學士課程[2024年或以後畢業]",
                ],
            },
            15: {
                1: [
                    "Higher Diploma in Early Childhood Education[Since 2020]",
                    "幼兒教育高級文憑[自2020年畢業]",
                ],
            },
            16: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2018 to 2023]",
                    "幼兒教育高級文憑[2018至2023年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Graduate from 2019 to 2022]",
                    "幼兒教育(榮譽)學士學位[2019至2022年畢業]",
                ],
            },
            17: {
                1: [
                    "Higher Diploma in Early Childhood Education[Since 2019]",
                    "幼兒教育高級文憑[自2019年畢業]",
                ],
            },
            18: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2019 to 2024]",
                    "幼兒教育高級文憑[2019至2024年畢業]",
                ],
            },
            19: {
                1: [
                    "Graduate from 2020 to 2026",
                    "幼兒教育高級文憑(融合教育)[2020至2026年畢業]",
                ],
            },
        },
        ccsCourseOption: {
            5: {
                6: [
                    "Advanced Diploma in Early Childhood Education Course[Course was renamed as Higher Diploma in Early Childhood Education Course w.e.f. September 2007.][Since30.6.2001]",
                    "幼兒教育高級文憑[由2007年9月起課程名稱改為幼兒教育高級文憑課程][自30.6.2001開始]",
                ],
                3: [
                    "Higher Diploma in Early Childhood Education[Since September 2007]",
                    "幼兒教育高級文憑課程[自2007年9月開始]",
                ],
                8: [
                    "Postgraduate Diploma in Early Childhood Education[Since June 2009]",
                    "幼兒教育深造文憑課程[自2009年6月開始]",
                ],
                5: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Since 2012/13 School Year]",
                    "幼兒教育學教育學士(榮譽)學位[自2012/13學年開始]",
                ],
            },
            6: {
                13: [
                    "Certificate in Kindergarten Education (Chinese Programme) (2 year day release or evening mixed mode)[Renamed as Higher Diploma in Kindergarten Education Programme (2-year day release mixed mode) and (2-year evening mixed mode) from 2009/10 school year. First cohort of graduates is expected in 2011.][Since operation]",
                    "幼稚園教育證書(中文)課程(二年日間/夜間混合制)[由2009/10學年開始，課程名稱改為幼稚園教育高級文憑(二年日間部份時間給假調訓混合制)及(二年夜間混合制)。第一批學生預期於2011年畢業][自開辦始]",
                ],
                14: [
                    "Certificate in Kindergarten Education (Chinese Programme) (3 year part-time evening)[Since operation]",
                    "幼稚園教育證書(中文)課程(三年夜間部份時間制)[自開辦始]",
                ],
                7: [
                    "Certificate in Early Childhood Education (Chinese) Programme (3 year full time)[Renamed as Higher Diploma in Early Childhood Education Programme (2-year full-time) and (3-year full-time) from 2009/10 school year. First cohort of graduates is expected in 2011 & 2012.][Since operation]",
                    "幼兒教育證書(中文)課程(三年全日制)[由2009/10學年開始，課程名稱改為幼兒教育高級文憑課程(二年全日制)及(三年全日制)。第一批學生預計於2011年及2012年畢業]",
                ],
                8: [
                    "Bachelor of Education (Honours) (Early Childhood Education) [Bed(ECE)] (4 year full time)[Since 13.7.2005]",
                    "幼兒教育榮譽學士(四年全日制)[自13.7.2005開始]",
                ],
                9: [
                    "Bachelor of Education (Honours) (Early Childhood Education) [Bed(ECE)] (5 year full time)[Graduate from 2016/17 School Year onwards]",
                    "幼兒教育榮譽學士(五年全日制)[自2016/17學年或以後畢業]",
                ],
                18: [
                    "Master of Education (ECE Specialization)#[2005-07EntryOnly]",
                    "[Graduates are required to be qualified kindergarten teacher or child care worker and have satisfactorily completed additional modules in the areas of “Children with Diverse Needs”, “Parental Involvement in Early Childhood Education” and “Educational and Administrative Management in early Childhood settings”at the certificate level or above.]",
                ],
                19: [
                    "Postgraduate Diploma in Education (Early Childhood Education) [PGDE(ECE)] (2 year part-time in-service)[Since June 2007]",
                    "學位教師教育文憑(幼兒教育)[PGDE(ECE)](二年在職部份時間制)[自2007年6月開始]",
                ],
                10: [
                    "Postgraduate Diploma in Education (Early Childhood Education)[PGDE(ECE)](2 year part-time)[Since 2015/16 School Year]",
                    "學位教師教育深造文憑(幼兒教育)(二年兼讀制)[自2015/16學年開始]",
                ],
                11: [
                    "Postgraduate Diploma in Education (Early Childhood Education) [PGDE(ECE)] (1 Year Full-time)",
                    "學位教師教育深造文憑(幼兒教育)(一年全日制)[自2017/18學年或以後畢業]",
                ],
            },
            2: {
                9: [
                    "Higher Diploma in Pre-primary Education [Graduates of the Higher Diploma in Pre-primary Education who graduated before 31.5.2001 could apply for qualification recognition and they will be assessed on individual basis.][Since 31.5.2001]",
                    "學前教育高級文憑[於31.5.2001前修畢學前教育高級文憑之學員，可申請學歷認可，並將根據個別情況審批其學歷][自31.5.2001開始]",
                ],
                8: [
                    "Bachelor of Arts (Honours) in Pre-primary Education[Since 18.2.2002]",
                    "學前教育(榮譽)文學士學位課程[自18.2.2002開始]",
                ],
            },
            3: {
                8: [
                    "Higher Diploma in Child Care and Education (pre-service) (3 year full time)[Since 27.11.2001]",
                    "幼兒教育高級文憑(三年全日職前訓練制)[自27.11.2001開始]",
                ],
                11: [
                    "Higher Diploma in Child Care and Education (part-time module accumulation course)[Since 27.11.2001]",
                    "幼兒教育高級文憑(部份時間單元儲修制)[自27.11.2001開始]",
                ],
                12: [
                    "Two-year In-service Certificate in Early Childhood Education Course(Higher Diploma in Child Care and education)[Since operation]",
                    "二年制在職幼兒教育證書課程(幼兒教育高級文憑)[自開辦始]",
                ],
                13: "Higher Diploma in Child Education and Management#(one year full time top-up programme with two year full time Diploma Programme in Child Care and Education)[Sinceoperation]",
                9: [
                    "Higher Diploma in Child Care and Education (pre-service 2 year full time)[Graduates from July 2009 onwards]",
                    "幼兒教育高級文憑(兩年全日職前訓練制)[自2009年7月或以後畢業生開始]",
                ],
            },
            4: {
                1: [
                    "Higher Diploma in Child Care and Education (pre-service 3 year full time)[Since operation]",
                    "幼兒教育高級文憑(三年全日職前訓練制)[自開辦始]",
                ],
                5: [
                    "Higher Diploma in Child Care and Education (part-time module accumulation course)[Since operation]",
                    "幼兒教育高級文憑(部份時間單元儲修制)[自開辦始]",
                ],
                2: [
                    "Higher Diploma in Child Care and Education (pre-service 2 year full time)[Since operation]",
                    "幼兒教育高級文憑(兩年全日職前訓練制)[自開辦始]",
                ],
                3: [
                    "Higher Diploma in Child Care and Education (3-year part time evening)[Graduates from 2008 to 2012 could be registered with satisfactory completion of the Certificate in Basic Child Care Work (Bridging Course) organised by The Hong Kong Institute of Vocational Education (Sha Tin).][Graduate from 2013 onwards]",
                    "幼兒教育高級文憑（三年晚間兼讀制）[2008至2012年期間的畢業生，可透過成功完成香港專業教育學院沙田分校舉辦的「基本幼兒工作証書(銜接課程)」，以達到註冊要求]",
                ],
                4: [
                    "Higher Diploma in Special Child Care and Inclusive Education[Graduate from 2019 to 2022]",
                    "特殊幼兒照顧及融合教育高級文憑[2019至2022年畢業]",
                ],
            },
            7: {
                1: "PGDE (Major in Early Childhood Education)#[Since9.2.2007]",
                2: [
                    "Bachelor of Science in Applied Child Development[Since operation]",
                    "理學士(應用兒童發展)[自開辦始]",
                ],
                3: [
                    "Bachelor of Education in Early Childhood Education and Special Education (5-year Full-time)[Graduate from 2024 onwards]",
                    "教育學士(幼兒教育及特殊教育)(五年全日制)[2024年或以後畢業]",
                ],
            },
            8: {
                1: "Diploma in Early Childhood Education#[Since 28.2.2007]",
                2: [
                    "Bachelor of Education with Honours in Early Childhood Education (Leadership and Special Educational Needs)[Graduate from 2022 onwards]",
                    "教育榮譽學士(幼兒教育：領導及特殊教育需要)[2022年或以後畢業]",
                ],
            },
            9: {
                1: "Diploma in Enlightened Early Childhood Education#[Since31.3.2008]",
                2: [
                    "Higher Diploma in Early Childhood Education[Since 2012/13 School Year]",
                    "幼兒教育高級文憑[自2012/13學年開始]",
                ],
            },
            14: {
                3: "Certificate in Early Childhood Education#[Since11.9.2006]",
                1: "Postgraduate Diploma in Education (Early Childhood Education)[Graduate from 2016/17 School Year onwards]",
                2: [
                    "Bachelor of Education Programme in Early Childhood Education[Graduate from 2024 onwards]",
                    "幼兒教育教育學士課程[2024年或以後畢業]",
                ],
            },
            15: {
                1: [
                    "Higher Diploma in Early Childhood Education[Since 2020]",
                    "幼兒教育高級文憑[自2020年畢業]",
                ],
            },
            10: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.][Graduate from 2016 to 2024]",
                    "幼兒教育高級文憑[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。][2016 至 2024 年畢業]",
                ],
            },
            11: {
                1: [
                    "Higher Diploma in Early Childhood Education [Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.][Graduate from 2019 to 2024]",
                    "幼兒教育高級文憑[於2024年修畢幼兒教育高級文憑之學員，其認可資格需取決於此課程在當時是否已獲審批。][2019 至 2024 年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education [BEd(ECE)][Graduate from 2022 to 2026]",
                    "幼兒教育(榮譽)學士[2022至2026年畢業]",
                ],
            },
            12: {
                1: [
                    "Higher Diploma in Early Childhood Education[Full-time students will graduate from 2017 to 2022 Part-time students will graduate in 2019 and 2020]",
                    "幼兒教育高級文憑[全日制學生於2017至2022年畢業,兼讀制學生於2019及2020年畢業]",
                ],
            },
            13: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2019 to 2023]",
                    "幼兒教育高級文憑[2019至2025年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Graduate from 2024 to 2027]",
                    "幼兒教育榮譽學士[2024至2027年畢業]",
                ],
            },
            16: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2018 to 2023]",
                    "幼兒教育高級文憑[2018至2023年畢業]",
                ],
                2: [
                    "Bachelor of Education (Honours) in Early Childhood Education[Graduate from 2019 to 2022]",
                    "幼兒教育(榮譽)學士學位[2019至2022年畢業]",
                ],
            },
            17: {
                1: [
                    "Higher Diploma in Early Childhood Education[Since 2019]",
                    "幼兒教育高級文憑[自2019年畢業]",
                ],
            },
            18: {
                1: [
                    "Higher Diploma in Early Childhood Education[Graduate from 2019 to 2024]",
                    "幼兒教育高級文憑[2019至2024年畢業]",
                ],
            },
            19: {
                1: [
                    "Higher Diploma in Early Childhood Education (Inclusive Education)[HDECE(IE)][Graduate from 2020 to 2026]",
                    "幼兒教育高級文憑(融合教育)[2020至2026年畢業]",
                ],
            },
        },
        // ccwSchoolOption: {
        //     1: "SWD,Training Section",
        //     2: "Hong Kong Polytechnic University",
        //     3: "The Hong Kong Institute of Vocational Education (Lee Wai Lee)",
        //     4: "The Hong Kong Institute of Vocational Education (Sha Tin)",
        //     5: "Hong Kong Baptist University, School of Continuing Education",
        //     6: "Hong Kong Institute of Education / The Education University of Hong Kong",
        //     7: "The University of Hong Kong",
        //     8: "The Open University of Hong Kong / Hong Kong Metropolitan University",
        //     9: "Li Ka Shing Institute of Professional and Continuing Education / Li Ka Shing School of Professional and Continuing Education The Open University of Hong Kong / Hong Kong Metropolitan University Li Ka Shing School of Professional and Continuing Education",
        //     10: "Yew Chung Community College",
        //     11: "Yew Chung College of Early Childhood Education",
        //     12: "Caritas Institute of Community Education",
        //     13: "Caritas Institute of Higher Education",
        //     14: "The Chinese University of Hong Kong",
        //     15: "The School of Continuing and Professional Studies of the Chinese University of Hong Kong",
        //     16: "Tung Wah College",
        //     17: "Lingnan Institute of Further Education",
        //     18: "Gratia Christian College",
        //     19: "Hong Kong College of Technology (HKCT) Institute of Higher Education",
        // },
        // ccsSchoolOption: {
        //     5: "Hong Kong Baptist University, School of Continuing Education",
        //     6: "Hong Kong Institute of Education / The Education University of Hong Kong",
        //     2: "Hong Kong Polytechnic University",
        //     3: "The Hong Kong Institute of Vocational Education (Lee Wai Lee)",
        //     4: "The Hong Kong Institute of Vocational Education (Sha Tin)",
        //     7: "The University of Hong Kong",
        //     8: "The Open University of Hong Kong / Hong Kong Metropolitan University",
        //     9: "Li Ka Shing Institute of Professional and Continuing Education / Li Ka Shing School of Professional and Continuing Education The Open University of Hong Kong / Hong Kong Metropolitan University Li Ka Shing School of Professional and Continuing Education",
        //     14: "The Chinese University of Hong Kong",
        //     15: "The School of Continuing and Professional Studies of the Chinese University of Hong Kong",
        //     10: "Yew Chung Community College",
        //     11: "Yew Chung College of Early Childhood Education",
        //     12: "Caritas Institute of Community Education",
        //     13: "Caritas Institute of Higher Education",
        //     16: "Tung Wah College",
        //     17: "Lingnan Institute of Further Education",
        //     18: "Gratia Christian College",
        //     19: "Hong Kong College of Technology (HKCT) Institute of Higher Education",
        // },
        // ccwCourseOption: {
        //     1: {
        //         1: "In-service Training Course for Nursery Workers*  [Since 13.8.1979]",
        //         2: "In-service Training Course for Crèche Workers*  [Since 13.8.1979]",
        //         3: "In-service Training Course for Playgroup Leaders*  [Since 13.8.1979]",
        //         4: "Pre-school Education Course Service Children Education Authority, Teachers' Centre, British Forces, HK*  [Since 13.8.1979]",
        //         5: "Hong Kong Nursery Workers' Training Course, joint project of SWD &YWCA*  [Since 13.8.1979]",
        //         6: "Elementary Child Care Course*  [Since 6.11.1979]",
        //     },
        //     2: {
        //         1: "Certificate in Child Care (1 year full time)*  [Since 13.8.1979]",
        //         2: "Part-time Day Release Certificate Course in Child Care (2 year part-time)*  [Since 13.8.1979]",
        //         3: "In-service Training Course for Nursery Workers*  [Since 5.5.1988]",
        //         4: "Basic Course for Child Care Workers*  [Since 5.5.1988]",
        //         5: "Basic Course for English-speaking Child Care Workers*  [Since 5.5.1988]",
        //         6: "The Certificate Course in Pre-primary Education (Distance Learning Mode)  [Since 10.7.1989]",
        //         7: "Certificate Course in Pre-primary Education for 2000/2001 (1 year pre-service full-time)  [Since operation]",
        //         8: [
        //             "Bachelor of Arts (Honours) in Pre-primary Education  [Since 18.2.2002]",
        //             "[Students who have successfully completed Stage 1 and 2 of the Bachelor of Arts (Honours) in Pre-primary Education may apply for individual recognition of Child Care worker equivalent qualification.]",
        //         ],
        //     },
        //     3: {
        //         1: "Certificate Course in Child Care*  [Since 6.2.1981]",
        //         2: "Certificate in Care of Pre-school Children (2 year full-time)*  [Since 5.5.1988]",
        //         3: "Certificate in Child Care (1 year full time pre-service mode)  [Since 5.5.1988]",
        //         4: "Certificate in Child Care (2 year part-time day release in-service mode)  [Since 5.5.1988]",
        //         5: [
        //             "Vocational Certificate in Basic Child Care Work (1 year part-time day release in-service mode)  [Since 3.3.1995]",
        //             "The course was named as Certificate in Basic Child Care Work (1 year part-time day release in-service mode) prior to 1999-2000.",
        //         ],
        //         6: "Basic Course for English-speaking Child Care Workers*  [Since 3.3.1995]",
        //         7: "Diploma in Child Care and Education (pre-service 2 year full time)  [Since 27.11.2001]",
        //         8: [
        //             "Higher Diploma in Child Care and Education (pre-service 3 year full time)  [Since 27.11.2001]",
        //             "[Students who have successfully completed Year One of Higher Diploma in Child Care & Education may apply for individual assessment of Child Care Worker equivalent qualification.]",
        //         ],
        //         9: "Higher Diploma in Child Care and Education (pre-service 2 year full time)  [Graduates from July 2009 onwards]",
        //     },
        //     4: {
        //         1: "Higher Diploma in Child Care and Education (pre-service 3 year full time)  [Since operation]",
        //         2: "Higher Diploma in Child Care and Education (pre-service 2 year full time)  [Since operation]",
        //         3: [
        //             "Higher Diploma in Child Care and Education (3-year part time evening)  [Graduate from 2013 onwards]",
        //             "[Graduates from 2008 to 2012 could be registered with satisfactory completion of the Certificate in Basic Child Care Work (Bridging Course) organised by The Hong Kong Institute of Vocational Education (Sha Tin).]",
        //         ],
        //         4: "Higher Diploma in Special Child Care and Inclusive Education  [Graduate from 2019 to 2022]",
        //     },
        //     5: {
        //         1: [
        //             "Certificate Course in Early Childhood Education  [Since 4.6.1997]",
        //             "[Graduates before 4.6.1997 could be registered with completion of the Conversion Programme in Early Childhood Education organized by HKBU.]",
        //         ],
        //         2: "One-year Pre-service Basic Early childhood Education Course for 2001-02  [Since operation]",
        //         3: "Higher Diploma in Early Childhood Education  [Since September 2007]",
        //         4: "Postgraduate Diploma in Early Childhood Education  [Since June 2009]",
        //         5: "Bachelor of Education (Honours) in Early Childhood Education  [Since 2012/13 School Year]",
        //     },
        //     6: {
        //         1: "Qualified Kindergarten Teacher Education Course (Chinese) (1 year day release or evening mixed mode)  [Since 9.12.1997]",
        //         2: "Qualified Kindergarten Teacher Education (Conversion) Course (Chinese) (1 year day release or evening mixed mode)  [Since 9.12.1997]",
        //         3: "Qualified Kindergarten Teacher Education Course (English) (1 year day release mode)  [Since 3.3.2001]",
        //         4: "Qualified Kindergarten Teacher Education Course (Chinese) (2 year part-time evening)  [Since 5.6.2001]",
        //         5: "Qualified Kindergarten Teacher Education Course (Conversion) (Chinese) (2 year part-time evening)  [Since 5.6.2001]",
        //         6: "Qualified Kindergarten Teacher Education Course (Chinese) (1 year full time)  [Since 5.6.2001]",
        //         7: [
        //             "Certificate in Early Childhood Education (Chinese) Programme (3 year full time)  [Since 30.8.1999]",
        //             "[Renamed as Higher Diploma in Early Childhood Education Programme (2-year full-time) and (3-year full-time) from 2009/10 school year. First cohort of graduates is expected in 2011 & 2012.]",
        //         ],
        //         8: "Bachelor of Education (Honours) (Early Childhood Education)[Bed(ECE)] (4 year full time)  [Since 13.7.2005]",
        //         9: "Bachelor of Education (Honours) (Early Childhood Education)[Bed(ECE)] (5 year full time)  [Graduate from 2016/17 School Year onwards]",
        //         10: "Postgraduate Diploma in Education (Early Childhood Education)[PGDE(ECE)] (2 year part-time in-service)  [Since 13.7.2005]",
        //         11: "Postgraduate Diploma in Education (Early Childhood Education)[PGDE(ECE)] (2 year part-time)  [Since 2015/16 School Year]",
        //         12: "Postgraduate Diploma in Education (Early Childhood Education)[PGDE(ECE)] (1 Year Full-time)  [Graduate from 2017/18 School Year onwards]",
        //     },
        //     7: {
        //         1: "PGDE (Major in Early Childhood Education)*  [Since 9.2.2007]",
        //         2: "Bachelor of Science in Applied Child Development  [Since operation]",
        //         3: "Bachelor of Education in Early Childhood Education and Special Education (5-year Full-time)  [Graduate from 2024 onwards]",
        //     },
        //     8: {
        //         1: "Diploma in Early Childhood Education  [Since 28.2.2007]",
        //         2: "Bachelor of Education with Honours in Early Childhood Education (Leadership and Special Educational Needs)  [Graduate from 2022 onwards]",
        //     },
        //     9: {
        //         1: "Diploma in Enlightened Early Childhood Education*  [Since 31.3.2008]",
        //         2: "Higher Diploma in Early Childhood Education  [Since 2012/13 School Year]",
        //     },
        //     10: {
        //         1: [
        //             "Higher Diploma in Early Childhood Education  [Graduate from 2016 to 2024]",
        //             "[Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.]",
        //         ],
        //     },
        //     11: {
        //         1: [
        //             "Higher Diploma in Early Childhood Education  [Graduate from 2019 to 2024]",
        //             "[Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.]",
        //         ],
        //         2: "Bachelor of Education (Honours) in Early Childhood Education [BEd(ECE)]  [Graduate from 2022 to 2026]",
        //     },
        //     12: {
        //         1: "Higher Diploma in Early Childhood Education  [Full-time students will graduate from 2017 to 2022, Part-time students will graduate in 2019 and 2020]",
        //     },
        //     13: {
        //         1: "Higher Diploma in Early Childhood Education  [Graduate from 2019 to 2025]",
        //         2: "Bachelor of Education (Honours) in Early Childhood Education  [Graduate from 2024 to 2027]",
        //     },
        //     14: {
        //         1: "Postgraduate Diploma in Education (Early Childhood Education)  [Graduate from 2016/17 School Year onwards]",
        //         2: "Bachelor of Education Programme in Early Childhood Education  [Graduate from 2024 onwards]",
        //     },
        //     15: {
        //         1: "Higher Diploma in Early Childhood Education  [Since 2020]",
        //     },
        //     16: {
        //         1: "Higher Diploma in Early Childhood Education  [Graduate from 2018 to 2023]",
        //         2: "Bachelor of Education (Honours) in Early Childhood Education  [Graduate from 2019 to 2022]",
        //     },
        //     17: {
        //         1: "Higher Diploma in Early Childhood Education  [Since 2019]",
        //     },
        //     18: {
        //         1: "Higher Diploma in Early Childhood Education  [Graduate from 2019 to 2024]",
        //     },
        //     19: {
        //         1: "Higher Diploma in Early Childhood Education (Inclusive Education) [HDECE(IE)]  [Graduate from 2020 to 2026]",
        //     },
        // },
        // ccsCourseOption: {
        //     5: {
        //         6: [
        //             "Advanced Diploma in Early Childhood Education Course  [Since 30.6.2001]",
        //             "[Course was renamed as Higher Diploma in Early Childhood Education Course w.e.f. September 2007.]",
        //         ],
        //         3: "Higher Diploma in Early Childhood Education  [Since September 2007]",
        //         8: "[Course was renamed as Higher Diploma in Early Childhood Education Course w.e.f. September 2007.]",
        //         5: "Bachelor of Education (Honours) in Early Childhood Education  [Since 2012/13 School Year]",
        //     },
        //     6: {
        //         13: [
        //             "Certificate in Kindergarten Education (Chinese Programme) (2 year day release or evening mixed mode)  [Since operation]",
        //             "[Renamed as Higher Diploma in Kindergarten Education Programme (2-year day release mixed mode) and (2-year evening mixed mode) from 2009/10 school year. First cohort of graduates is expected in 2011.]",
        //         ],
        //         14: "Certificate in Kindergarten Education (Chinese Programme) (3 year part-time evening)  [Since operation]",
        //         7: [
        //             "Certificate in Early Childhood Education (Chinese) Programme (3 year full time)  [Since operation]",
        //             "[Renamed as Higher Diploma in Early Childhood Education Programme (2-year full-time) and (3-year full-time) from 2009/10 school year. First cohort of graduates is expected in 2011 & 2012.]",
        //         ],
        //         8: "Bachelor of Education (Honours) (Early Childhood Education) [Bed(ECE)] (4 year full time)  [Since 13.7.2005]",
        //         9: "Bachelor of Education (Honours) (Early Childhood Education) [Bed(ECE)] (5 year full time)  [Graduate from 2016/17 School Year onwards]",
        //         18: [
        //             "Master of Education (ECE Specialization)*  [2005-07 Entry Only]",
        //             "[Graduates are required to be qualified kindergarten teacher or child care worker and have satisfactorily completed additional modules in the areas of “Children with Diverse Needs”, “Parental Involvement in Early Childhood Education” and “Educational and Administrative Management in early Childhood settings”at the certificate level or above.]",
        //         ],
        //         19: "Master of Education (ECE Specialization)*  [2005-07 Entry Only]",
        //         10: "Postgraduate Diploma in Education (Early Childhood Education) [PGDE(ECE)] (2 year part-time in-service)  [Since June 2007]",
        //         11: "Postgraduate Diploma in Education (Early Childhood Education) [PGDE(ECE)] (2 year part-time)  [Since 2015/16 School Year]",
        //     },
        //     2: {
        //         9: [
        //             "Higher Diploma in Pre-primary Education  [Since 31.5.2001]",
        //             "[Graduates of the Higher Diploma in Pre-primary Education who graduated before 31.5.2001 could apply for qualification recognition and they will be assessed on individual basis.]",
        //         ],
        //         8: [
        //             "Bachelor of Arts (Honours) in Pre-primary Education  [Since 18.2.2002]",
        //             "[Graduates of the Higher Diploma in Pre-primary Education who graduated before 31.5.2001 could apply for qualification recognition and they will be assessed on individual basis.]",
        //         ],
        //     },
        //     3: {
        //         8: "Higher Diploma in Child Care and Education (pre-service) (3 year full time)  [Since 27.11.2001]",
        //         11: "Higher Diploma in Child Care and Education (part-time module accumulation course)  [Since 27.11.2001]",
        //         12: "Two-year In-service Certificate in Early Childhood Education Course (Higher Diploma in Child Care and education)  [Since operation]",
        //         13: "Higher Diploma in Child Education and Management*  [Since operation]",
        //         9: "Higher Diploma in Child Care and Education (pre-service 2 year full time)  [Graduates from July 2009 onwards]",
        //     },
        //     4: {
        //         1: "Higher Diploma in Child Care and Education (pre-service 3 year full time)  [Since operation]",
        //         5: "Higher Diploma in Child Care and Education (part-time module accumulation course)  [Since operation]",
        //         2: "Higher Diploma in Child Care and Education (pre-service 2 year full time)  [Graduates from July 2009 onwards]",
        //         3: [
        //             "Higher Diploma in Child Care and Education (3-year part time evening)  [Graduate from 2013 onwards]",
        //             "[Graduates from 2008 to 2012 could be registered with satisfactory completion of the Certificate in Basic Child Care Work (Bridging Course) organised by The Hong Kong Institute of Vocational Education (Sha Tin).]",
        //         ],
        //         4: "Higher Diploma in Special Child Care and Inclusive Education  [Graduate from 2019 to 2022]",
        //     },
        //     7: {
        //         1: "PGDE (Major in Early Childhood Education)*  [Since 9.2.2007]",
        //         2: "Bachelor of Science in Applied Child Development  [Since operation]",
        //         3: "Bachelor of Education in Early Childhood Education and Special Education (5-year Full-time)  [Graduate from 2024 onwards]",
        //     },
        //     8: {
        //         1: "Diploma in Early Childhood Education  [Since 28.2.2007]",
        //         2: "Bachelor of Education with Honours in Early Childhood Education (Leadership and Special Educational Needs)  [Graduate from 2022 onwards]",
        //     },
        //     9: {
        //         1: "Diploma in Enlightened Early Childhood Education*  [Since 31.3.2008]",
        //         2: "Higher Diploma in Early Childhood Education  [Since 2012/13 School Year]",
        //     },
        //     14: {
        //         3: "Certificate in Early Childhood Education*  [Since 11.9.2006]",
        //         1: "Postgraduate Diploma in Education (Early Childhood Education)  [Graduate from 2016/17 School Year onwards]",
        //         2: "Bachelor of Education Programme in Early Childhood Education  [Graduate from 2024 onwards]",
        //     },
        //     15: {
        //         1: "Higher Diploma in Early Childhood Education  [Since 2020]",
        //     },
        //     10: {
        //         1: [
        //             "Higher Diploma in Early Childhood Education  [Graduate from 2016 to 2024]",
        //             "[Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.]",
        //         ],
        //     },
        //     11: {
        //         1: [
        //             "Higher Diploma in Early Childhood Education  [Graduate from 2019 to 2024]",
        //             "[Graduates of the Higher Diploma in Early Children Education who graduated in 2024 are eligible for recognition subject to the course is being approved at that time.]",
        //         ],
        //         2: "Bachelor of Education (Honours) in Early Childhood Education [BEd(ECE)]  [Graduate from 2022 to 2026]",
        //     },
        //     12: {
        //         1: "Higher Diploma in Early Childhood Education  [Full-time students will graduate from 2017 to 2022, Part-time students will graduate in 2019 and 2020]",
        //     },
        //     13: {
        //         1: "Higher Diploma in Early Childhood Education  [Graduate from 2019 to 2025]",
        //         2: "Bachelor of Education (Honours) in Early Childhood Education  [Graduate from 2024 to 2027]",
        //     },
        //     16: {
        //         1: "Higher Diploma in Early Childhood Education  [Graduate from 2018 to 2023]",
        //         2: "Bachelor of Education (Honours) in Early Childhood Education  [Graduate from 2019 to 2022]",
        //     },
        //     17: {
        //         1: "Higher Diploma in Early Childhood Education  [Since 2019]",
        //     },
        //     18: {
        //         1: "Higher Diploma in Early Childhood Education  [Graduate from 2019 to 2024]",
        //     },
        //     19: {
        //         1: "Higher Diploma in Early Childhood Education (Inclusive Education) [HDECE(IE)]  [Graduate from 2020 to 2026]",
        //     },
        // },
        nameEn: "Name(in English)",
        nameCn: "Name(in Chinese)",
        documentType: "Document Type",
        hKid: "Identity Card Number",
        passport: "Passport Number",
        dateOfBirth: "Date of birth",
        residentialAddress: "Residential Address",
        telNo: "Tel.No.",
        dcTelNo: "Daytime Contact/Mobile Tel.No",
        emailAddress: "Email Address",
        nameOfWorkingCentre: "Name of Working Centre",
        workingCentreAddress: "Working Centre Address",
        telNoAddress: "Tel. No.",
        awardedByA: "Awarded by",
        awardedByB: "Awarded by",
        first: "(A)",
        second: "(B)",
        third: "(C)",
        courseName: "Course Name",
        othersSpecify: "Others (Please specify)",
        nameOfCentre: "Name of Pre-primary institution/Child Care Centre",
        postHeld: "Post Held",
        dateOfCommencement: "Date of Commencement",
        dateOfResignation: "Have you left the position?",
        dateOfLeaving: "Date of Leaving",
        ageRange: "Age Range of Children Served",
        school: "Hong Kong Institute of Education",
        schoolCourseName: "Higher Diploma in Early Childhood Education",
        ageRangeTips: "e.g. “2-3” for 2-3 years",
        popMessage:
            "This course is eligible for CCS and CCW as well. Would you like to  apply for CCS and CCW at the same time?",
        yes: "Yes",
        no: "No",
        ccwPopMessage:
            "The selected course(s) is/are only eligible for Child Care Worker. Do you want to apply for registration as Child Care Worker only?",
        ccsPopMessage:
            "The selected course(s) is/are only eligible for  Child Care Supervisor. Do you want to apply for registration as Child Care Supervisor only?",
        ccwMessage:
            "The selected course(s) is/are only eligible for Child Care Worker. Please select a course/courses that are eligible for both Child Care Worker and Child Care Supervisor, or change to apply for registration as Child Care Worker only in step 2.",
        ccsMessage:
            "The selected course(s) is/are only eligible for Child Care Supervisor. Please select a course/courses that are eligible for both Child Care Worker and Child Care Supervisor, or change to apply for registration as Child Care Supervisor only in step 2.",
    },
    errorMsg: {
        E01: "Please input the correct format.",
        E02: "Please input a valid date",
        E03: "Please input either Identity Card Number or Passport Number",
        E04: "Please fill in one between your {{fieldOne}} and {{fieldTwo}} at least",
        E0116: "Maximum character length:",
        E0117: "Minimum character length:",
        E05: "Please fill in at least one item",
        telNo: "Please input either Tel.No or Daytime Contact/Mobile Tel.No",
        ageRange:
            "Please input a valid Age Range of Children Served (e.g. “2-3” for 2-3 years)",
        na: "N/A",
        E06: "Please complete",
        repeatCourse: "Please select a non-duplicated course",
        ccsAndccwRequired:
            "If you wish to be registered as a Child Care Worker and a Child Care Supervisor at the same time, you have to complete an approved course qualifying for registration of Child Care Worker and Child Care Supervisor respectively.",
    },
};
export default Form041EN;
